export const nullValuesReplacer = (showNullValues: boolean): any => {
  return showNullValues ? null : hideNullValuesReplacer;
};

const hideNullValuesReplacer = (_: string, value: any) => {
  return value === null ? undefined : value;
};
